import React from 'react';
import { Link } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
export const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { t } = useTranslation();
    return (
        <>
            <div className="container p-2 mx-auto">
                <div className="flex flex-row flex-wrap py-4">
                    <aside className="w-full sm:w-1/3 md:w-1/4 px-2">
                        <div className="sticky top-0 p-4 bg-white rounded-xl w-full">
                            <header className="mb-6">
                                <ul className="nav flex flex-col overflow-hidden">
                                    <li className="nav-item">
                                        <Link className="nav-link hover:text-blue-600 truncate" to={`/`}>
                                            <span className="fa fa-home mr-2"></span> {t('home')}{' '}
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link hover:text-blue-600 truncate" to={`/about`}>
                                            <span className="fa fa-list-alt mr-2"></span> {t('about')}{' '}
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link hover:text-blue-600 truncate" to={`/profile`}>
                                            <span className="fa fa-cart-plus mr-2"></span> {t('profile')}{' '}
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link
                                            className="nav-link hover:text-blue-600 truncate"
                                            to={`/cursos`}
                                        >
                                            <span className="fa fa-cart-plus mr-2"></span> Cursos
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link
                                            className="nav-link hover:text-blue-600 truncate"
                                            to={`/curso/piano-basico`}
                                        >
                                            <span className="fa fa-cart-plus mr-2"></span> Piano básico
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link
                                            className="nav-link hover:text-blue-600 truncate"
                                            to={`/curso/expansion-villancicos`}
                                        >
                                            <span className="fa fa-cart-plus mr-2"></span> Expansión: ¡Villancicos!
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link
                                            className="nav-link hover:text-blue-600 truncate"
                                            to={`/curso/piano-melodias`}
                                        >
                                            <span className="fa fa-cart-plus mr-2"></span> Piano melodias
                                        </Link>
                                    </li>

                                    {/* <li className="nav-item">
                                        <Link className="nav-link hover:text-blue-600 truncate" to={`/signin`}>
                                            <span className="fa fa-list-alt mr-2"></span> {t('signIn')}{' '}
                                        </Link>
                                    </li> 
                                    <li className="nav-item">
                                        <a className="nav-link hover:text-blue-600" href="javascript:void(0)">
                                            <span className="fa fa-user mr-2"></span> Customers{' '}
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link hover:text-blue-600" href="javascript:void(0)">
                                            <span className="fa fa-chart-bar mr-2"></span> Reports{' '}
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link hover:text-blue-600" href="javascript:void(0)">
                                            <span className="fa fa-layer-group mr-2"></span> Integrations{' '}
                                        </a>
                                    </li> */}
                                </ul>
                            </header>
                        </div>
                    </aside>
                    <main role="main" className="w-full sm:w-2/3 md:w-3/4 pt-1 px-2">
                        <main>{children}</main>
                        <hr className="my-5" />
                    </main>
                </div>
            </div>
            <footer className="bg-black mt-auto">
                <div className="container p-4 text-white mx-auto">
                    <h1 className="text-2xl">Footer</h1>
                    <div className="flex">
                        <div className="flex-grow flex flex-col">
                            <a href="/#home">Boom</a>
                            <a href="#">Boom</a>
                            <a href="#">Boom</a>
                            <a href="#">Boom</a>
                        </div>
                        <div className="flex-grow flex flex-col">
                            <a href="#">Boom</a>
                            <a href="#">Boom</a>
                            <a href="#">Boom</a>
                            <a href="#">Boom</a>
                        </div>
                        <div className="flex-grow flex flex-col">
                            <a href="#">Boom</a>
                            <a href="#">Boom</a>
                            <a href="#">Boom</a>
                        </div>
                        <div className="flex-grow flex flex-col">
                            <a href="#">Boom</a>
                            <a href="#">Boom</a>
                            <a href="#">Boom</a>
                            <a href="#">Boom</a>
                        </div>
                    </div>
                    <div className="text-right text-xs py-4">
                        <a href="">&copy;2021 Someco Inc.</a>
                    </div>
                </div>
            </footer>
        </>
    );
};
